export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to
  if (path.endsWith('/')) return
  const nextPath = path + '/'
  const nextRoute = { path: nextPath, query, hash }
  return navigateTo(nextRoute, { redirectCode: 301 })
})
